import React, { useMemo } from "react"
import styled from "styled-components"
import Text from "../../common/Text"
import Image, { generateSizes } from "../../common/Image"
import { getFontSize, getCssSizeValue, getHtmlFromRedactorField } from "@repo/utils"
import { BREAKPOINTS } from "../../../../styles/themeSettings"
import { getButtonBlockData } from "../Button"
import { useRouter } from "next/router"
import { TYPES } from "../../../../lib"

const Wrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	width: ${getCssSizeValue(241, BREAKPOINTS.MOBILE)};
	row-gap: ${getCssSizeValue(23, BREAKPOINTS.MOBILE)};
	height: 100%;
	cursor: pointer;
	.text {
		font-size: var(--font-size);
		//letter-spacing: calc(var(--font-size) * -0.04);
	}
	.image {
		max-width: ${getCssSizeValue(154, BREAKPOINTS.MOBILE)};
		aspect-ratio: 1;
		height: auto;
		transform: scale(1);
		transition: transform 0.3s ease-in-out;
	}
	&:hover {
		.image {
			transform: scale(1.05);
			transition: transform 0.3s ease-in-out;
		}
	}
	.button {
		margin-top: auto;
	}
	&.disabled {
		cursor: initial;
		pointer-events: none;
	}

	@media (min-width: ${({ theme }) => theme?.breakpoints?.tablet}px) {
		width: ${getCssSizeValue(446, BREAKPOINTS.TABLET)};
		row-gap: ${getCssSizeValue(25, BREAKPOINTS.TABLET)};
		.image {
			max-width: ${getCssSizeValue(210, BREAKPOINTS.TABLET)};
		}
	}

	@media (min-width: ${({ theme }) => theme?.breakpoints?.desktop || 1024}px) and (orientation: landscape) {
		width: ${getCssSizeValue(520, BREAKPOINTS.DESKTOP)};
		row-gap: ${getCssSizeValue(44, BREAKPOINTS.DESKTOP)};
		.image {
			max-width: ${getCssSizeValue(160, BREAKPOINTS.DESKTOP)};
		}
	}
`

const Top = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: column;
	row-gap: inherit;
	aspect-ratio: 241/260;
	.text {
		margin-bottom: auto;
	}

	@media (min-width: ${({ theme }) => theme?.breakpoints?.tablet}px) {
		aspect-ratio: 1.085;
	}

	@media (min-width: ${({ theme }) => theme?.breakpoints?.desktop || 1024}px) and (orientation: landscape) {
		//aspect-ratio: 580/450;
		aspect-ratio: 550/410;
	}
`

const Header = styled(Text)`
	--font-size: ${getFontSize(36, BREAKPOINTS.MOBILE)};
	font-weight: ${({ theme }) => theme.fontWeight.bold || 700};
	line-height: ${getFontSize(40, BREAKPOINTS.MOBILE)};
	letter-spacing: calc(var(--font-size) * -0.04);

	@media (min-width: ${({ theme }) => theme?.breakpoints?.tablet}px) {
		--font-size: ${getFontSize(75, BREAKPOINTS.TABLET)};
		line-height: ${getFontSize(88, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme?.breakpoints?.desktop || 1024}px) and (orientation: landscape) {
		--font-size: ${getFontSize(90, BREAKPOINTS.DESKTOP)};
		line-height: ${getFontSize(96, BREAKPOINTS.DESKTOP)};
		letter-spacing: -3.6px;
	}
`

const Description = styled(Text)`
	//margin-top: auto;
	--font-size: ${getFontSize(16, BREAKPOINTS.MOBILE)};
	line-height: ${getFontSize(26, BREAKPOINTS.MOBILE)};
	font-weight: ${({ theme }) => theme.fontWeight.regular || 400};

	@media (min-width: ${({ theme }) => theme?.breakpoints?.tablet}px) {
		--font-size: ${getFontSize(20, BREAKPOINTS.TABLET)};
		line-height: ${getFontSize(36, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme?.breakpoints?.desktop || 1024}px) and (orientation: landscape) {
		--font-size: ${getFontSize(24, BREAKPOINTS.DESKTOP)};
		line-height: ${getFontSize(36, BREAKPOINTS.DESKTOP)};
	}
`

export function getCardData(data) {
	const id = data?.id || ""
	const header = data?.header || ""
	const description = getHtmlFromRedactorField(data?.description || "")
	const soonMask = Boolean(data?.soonMask)
	const icon = {
		url: data?.icon?.url || "",
		alt: data?.icon?.alt || "card-image",
		width: data?.icon?.width || 0,
		height: data?.icon?.height || 1,
	}
	const button = getButtonBlockData(data)
	return {
		id,
		header,
		description,
		icon,
		button,
		soonMask,
	}
}
const sizes = generateSizes({ desktop: "9vw", tablet: "21vw", mobile: "40vw" })
const Card = ({ data, disabled }) => {
	const { id, header, description, icon, button } = getCardData(data)
	const router = useRouter()
	const slug = useMemo(() => {
		return button.typename === TYPES.PAGES.SERVICE_PAGE_RECORD ? `/services/${button.link}` : button.link
	}, [data])
	return (
		<Wrapper id={id} onClick={() => router.push(slug)} className={disabled ? "disabled" : ""}>
			<Top>
				<Image className="picto" src={icon.url} alt={icon.alt} fit="contain" focalPoint={{ x: 0, y: 0.5 }} sizes={sizes} />
				<Header>{header}</Header>
			</Top>
			<Description className="text" as="div" dangerouslySetInnerHTML={description} />
		</Wrapper>
	)
}

export default Card
